var script_loaded = false;

function loadJSscripts() {
    if (!script_loaded) {
        script_loaded = true;

        document.querySelectorAll("iframe.lazy").forEach(iframe => {
            const datasrc = iframe.dataset.src;
            if (datasrc) {
                iframe.src = datasrc;
            }
        });

        const scripts = document.getElementsByTagName("script");
        for (let i = 0; i < scripts.length; i++) {
            const script = scripts[i];
            
            if (script.getAttribute("data-src")) {
                script.setAttribute("src", script.getAttribute("data-src"));
                delete script.dataset.src;
            }
            
            if (script.getAttribute("type") === "text/lazyload") {
                const newScript = document.createElement("script");
                for (let j = 0; j < script.attributes.length; j++) {
                    const attr = script.attributes[j];
                    newScript.setAttribute(attr.name, attr.value);
                }
                newScript.type = "text/javascript";
                newScript.innerHTML = script.innerHTML;
                
                script.parentNode.replaceChild(newScript, script);
            }
        }

        const links = document.getElementsByTagName("link");
        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            if (link.getAttribute("data-href")) {
                link.setAttribute("href", link.getAttribute("data-href"));
                delete link.dataset.href;
            }
        }

        document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
    }
}

var activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];

activityEvents.forEach(function(eventName) {
    window.addEventListener(eventName, loadJSscripts, { once: true });
});